import { useState } from "react";
import { customerAccountApi } from "../api/service.api";

export const useExportExcel = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);

  const fetchData = async (fetchParams?: Record<string, any>) => {
    try {
      setLoading(true);

      const exportIdResponse: any = await customerAccountApi.getExportId(
        fetchParams || {}
      );

      const export_id = exportIdResponse?.data?.data?.export_id;

      return {
        is_success: true,
        export_id: export_id,
      };
    } catch (err: any) {
      console.log("Export customer accounts failed:", err);

      setError(err.message || "Something wrong");

      return {
        is_success: false,
        export_id: null,
      };
    } finally {
      setLoading(false);
    }
  };

  return {
    fetchData,
    loading,
    error,
  };
};
